import r from "../managers/braze-instance.js";
import tr from "./feature-flags-provider.js";
var nr = {
  i: !1,
  provider: null,
  o: function o() {
    return nr.t(), nr.provider || (nr.provider = new tr(r.l(), r.m(), r.p(), r.u()), r.v(nr.provider)), nr.provider;
  },
  t: function t() {
    nr.i || (r.g(nr), nr.i = !0);
  },
  destroy: function destroy() {
    nr.provider = null, nr.i = !1;
  }
};
export default nr;